import type { PaymentMethod, ReservationInitiatePaymentResponse } from '@repo/domain';
import { BusinessValidationError } from '@repo/domain-service';
import { addBreadcrumb } from '@repo/error';

interface SuccessParams {
  // Absent for a reservation the free parking time pays for in full.
  paymentMethod: PaymentMethod | undefined;
  response: ReservationInitiatePaymentResponse;
}

interface FailureParams {
  // Absent for a reservation the free parking time pays for in full.
  paymentMethod: PaymentMethod | undefined;
  error: unknown;
}

export const trackReservationSuccess = ({ paymentMethod, response }: SuccessParams): void => {
  addBreadcrumb({
    category: 'payment',
    message: 'Reservation attempt succeeded',
    level: 'info',
    data: { paymentMethod, reservationResponse: response },
  });
};

export const trackReservationFailure = ({ paymentMethod, error }: FailureParams): void => {
  const code = error instanceof BusinessValidationError ? error.code : undefined;
  addBreadcrumb({
    category: 'payment',
    message: code ? `Reservation attempt failed: ${code}` : 'Reservation attempt failed',
    level: 'info',
    data: { paymentMethod, code },
  });
};
